import React from 'react';
import { useSelector } from 'react-redux';
import { useRouteMatch } from 'react-router-dom';
import MainTemplate from 'pages/templates/MainTemplate';
import MbTabs from 'components/organisms/MbTabs';

import StatisticsMobon from './StatisticsMobon';
import StatisticsMedia from './StatisticsMedia';
import StatisticsEtc from './StatisticsEtc';
import Statistics from './Statistics';
import StatisticsHistory from './StatisticsHistory';
import ReportExl from './ReportExl';

const Calculate = () => {
  let { path } = useRouteMatch();
  const { menu } = useSelector(({ menu }) => ({
    menu: menu.list === null ? new Map() : menu.list,
  }));

  const tabList = () => {
    for (let curMenu of menu.values()) {
      if (typeof curMenu.subMenu !== 'undefined') {
        const cur = curMenu.subMenu.get(path);
        if (typeof cur !== 'undefined') {
          // 현재 2dapth url에 매칭되는 것이 있으면 그 메뉴의 하위 tab 반환
          return cur.subMenu;
        }
      }
    }
  };

  return (
    <MainTemplate>
      <MbTabs
        name="SalesStatistics"
        tabMenuList={tabList()}
        tabs={{
          '/sales/calculate': {
            tabComponent: (
              <>
                <Statistics />
              </>
            ),
          },
          '/sales/calculate/mobon': {
            tabComponent: (
              <>
                <StatisticsMobon />
              </>
            ),
          },
          '/sales/calculate/media': {
            tabComponent: (
              <>
                <StatisticsMedia />
              </>
            ),
          },
          '/sales/calculate/etc': {
            tabComponent: (
              <>
                <StatisticsEtc />
              </>
            ),
          },
          '/sales/calculate/history': {
            tabComponent: (
              <>
                <StatisticsHistory />
              </>
            ),
            isPop: true,
          },
          '/sales/calculate/exl': {
            tabComponent: (
              <>
                <ReportExl />
              </>
            ),
            isPop: true,
          },
        }}
      ></MbTabs>
    </MainTemplate>
  );
};

export default Calculate;
